import * as React from 'react'
import { IntegrationSettingsContextType } from './types'

const IntegrationSettingsContext = React.createContext<IntegrationSettingsContextType>(
  {} as IntegrationSettingsContextType
)

export default IntegrationSettingsContext
